import { render } from "./TenantCompanies.vue?vue&type=template&id=1f7e5e61&scoped=true"
import script from "./TenantCompanies.vue?vue&type=script&lang=js"
export * from "./TenantCompanies.vue?vue&type=script&lang=js"

import "./TenantCompanies.vue?vue&type=style&index=0&id=1f7e5e61&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7e5e61"]])

export default __exports__